import { Box } from "@mui/material";
import GardenMap from "../GardenMap/GardenMap";
import GardenLocationForm from "./GardenLocationForm";

export default function GardenLocation({
    garden,
    setGarden,
    weatherStations = [],
    onNext
}) {
    return (
        <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            <GardenMap
                garden={garden}
                setGarden={setGarden}
                weatherStations={weatherStations}
            />

            <GardenLocationForm
                garden={garden}
                setGarden={setGarden}
                weatherStations={weatherStations}
                onNext={onNext}
            />
        </Box>
    );
}
